















import { Component, Vue } from 'vue-property-decorator'
import store from '@/store'

@Component({
  name: 'notifications-header',
})
export default class NotificationsHeaderComponent extends Vue {
  private unsubscribe: any | null = null
  unread: number | null = null

  mounted(): void {
    this.unsubscribe = store.subscribe(() => (this.unread = store.getState().notifications.unread))
  }

  beforeDestroy(): void {
    this.unsubscribe()
  }
}
